/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:57]
Permissions to update outside the main branch: [true]
*/

import { selectOptionsToDropDown } from '@finbeat/react-toolkit';
import { AxiosInstance } from 'axios';
import { SelectOption } from 'models/api/prop';
import ResTable from 'models/api/table';
import {
    TradeOrg, TradeOrgFilterType,
    TradeOrgTableItem
} from 'models/api/tradeOrg';

const controller = '/tradeOrgs';

export const getTradeOrgsList = async (axios: AxiosInstance) => {
    const { data } = await axios.get<SelectOption[]>(controller + '/list');
    return data;
};

export const getTradeOrgs = async (axios: AxiosInstance, params: TradeOrgFilterType) => {
    const { data } = await axios.get<ResTable<TradeOrgTableItem>>(controller, {
        params,
    });
    return data;
};

export const getTradeOrg = async (axios: AxiosInstance, id: number | string) => {
    const response = await axios.get<TradeOrg>(controller + `/${id}`);
    return response.data;
};

export const getTradeOrgsExcel = async (axios: AxiosInstance, params?: TradeOrgFilterType) => {
    const { data } = await axios.get<Blob>(controller + '/excel', {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return data;
};

export const addTradeOrg = async (axios: AxiosInstance, item: FormData) =>
    await axios.post(controller, item, {
        headers: {
            "Content-Type": "multipart/form-data"
        },
    });

export const changeTradeOrg = async (axios: AxiosInstance, item: FormData) =>
    await axios.put<TradeOrg>(controller, item, {
        headers: {
            "Content-Type": "multipart/form-data"
        },
    });

export const getTradeOrgsDropDownList = async (axios: AxiosInstance) => {
    const data = await getTradeOrgsList(axios);
    const dropDown = selectOptionsToDropDown(data || []);
    return dropDown;
};

export const deleteTradeOrg = async (axios: AxiosInstance, id: number | string) =>
    await axios.delete(controller + `/${id}`);
